import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const FogIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 16" title={t`Fog`} {...props}>
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M1 5.667h9.333M3.333 10.333h9.334M4.889 8H15M4.111 3.333h3.111M6.444 12.667h3.89"
      fill="none"
    />
  </Icon>
);
